module.exports = __webpack_public_path__ + "img/profitability1.b7c5f2b3.png";